import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { TableFieldDefinition } from 'ah-common-lib/src/models';
import { useFeatureFlagStore } from '../stores';
import { ListResponse } from 'ah-api-gateways/models/rest/pagination';
import { CachedItem } from 'ah-common-lib/src/helpers';
import { FeatureFlag, FeatureFlagResponse } from 'ah-api-gateways';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';


export default /*#__PURE__*/_defineComponent({
  __name: 'FeatureFlagList',
  setup(__props) {

const featureFlagStore = useFeatureFlagStore();
const requestManager = useRequestManager().manager;

const fields: TableFieldDefinition[] = [
  { key: 'featureFlag', header: 'Name', sortable: false },
  { key: 'loadDate', header: 'Last Loaded', sortable: false },
  { key: 'treatment', header: 'Treatment', sortable: false },
  { key: 'actions', header: '', class: 'text-right', sortable: false },
];

const flags = computed<ListResponse<CachedItem<FeatureFlagResponse>>>(() => ({
  list: Object.values(featureFlagStore.featureFlags),
}));

function reloadFlag(key: string) {
  requestManager.newPromise(
    key,
    featureFlagStore.loadFeatureFlag({
      featureFlag: key as FeatureFlag,
      force: true,
    })
  );
}

function clearFlag(key: string) {
  featureFlagStore.featureFlags[key] && CachedItem.clearCachedItem(featureFlagStore.featureFlags[key]);
}

return { __sfc: true,featureFlagStore, requestManager, fields, flags, reloadFlag, clearFlag }
}

})